import { useAppSelector } from 'flow/hooks/useRedux';
import { twMerge } from 'tailwind-merge';
import { generatePath, useHistory } from 'react-router-dom';
import { ChatSessionKey, ChatUserKey } from 'flow/types/EntityKeys';

import { selectExtensionKeyFromChatUserKey } from 'flow/selectors/chat-selectors';
import {
    selectExtensionExists,
    selectOwnExtensionKey,
} from 'flow/selectors/ExtensionSelectors';
import { routes } from 'flow/types/routes';

interface Props {
    name: string;
    chatUserKey: ChatUserKey;
    sessionKey: ChatSessionKey;
}

const MessageMention = ({ name, chatUserKey, sessionKey }: Props) => {
    const history = useHistory();

    const extensionKey = useAppSelector((state) =>
        selectExtensionKeyFromChatUserKey(state, chatUserKey),
    );

    // A mention can name someone we hold no extension for, and there is nowhere
    // to send you for yourself — both stay plain text rather than a dead link.
    const extensionExists = useAppSelector((state) =>
        selectExtensionExists(state, extensionKey),
    );
    const ownExtensionKey = useAppSelector(selectOwnExtensionKey);

    const navigationKey =
        extensionExists && ownExtensionKey !== extensionKey
            ? extensionKey
            : null;

    const handleClick = navigationKey
        ? () =>
              history.push(
                  generatePath(routes['messages.id.settings.contact.key'], {
                      extensionKey: navigationKey,
                      id: sessionKey,
                  }),
                  { from: history.location.pathname },
              )
        : null;

    return (
        <button
            className={twMerge(
                'text-link',
                !handleClick ? 'cursor-default' : '',
            )}
            onClick={handleClick}
        >
            {name}
        </button>
    );
};

export default MessageMention;
